module.exports = __webpack_public_path__ + "static/media/menu_announcement_hoverActive.168e029f.svg";